import { global_store } from '@/store';

export default async function load_time() {
  await global_store.actions.get_time();
}
